import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../components/Button';
import { useTranslation } from 'react-i18next';
import useTheme from '../hooks/useTheme';

function Home() {
  const { t } = useTranslation();
  useTheme();

  const [tileBtn, setTileBtn] = useState({
    CommitmentsClosingWithOutstandingConditions: false,
    AllUpcomingClosing: false,
    PendingReview: false,
    YTDFundedDeals: false,
    SearchDeals: false,
  });

  useEffect(() => {
    setTileBtn((prevState) => ({
      ...prevState,
      CommitmentsClosingWithOutstandingConditions: window.CommitmentsClosingWithOutstandingConditions_View,
      AllUpcomingClosing: window.AllUpcomingClosing_View,
      PendingReview: window.PendingReview_View,
      YTDFundedDeals: window.YTDFundedDeals_View,
      SearchDeals: window.SearchDeals_View,
    }));
  }, []);

  return (
    <section className="h-full w-full flex justify-center items-center p-5">
      <div className="flex flex-wrap w-full h-fit justify-center items-center gap-4">
        {tileBtn.CommitmentsClosingWithOutstandingConditions && (
          <Link to="/commitments-closing-with-outstanding-conditions">
            <Button 
              variant="tile"
              style={{ color: 'var(--primary-button-text-color)' }}
              label={t('home.commitmentsClosingWithOutstandingConditions')}
            />
          </Link>
        )}
        {tileBtn.AllUpcomingClosing && (
          <Link to="/all-upcoming-closing">
            <Button 
              variant="tile"
              style={{ color: 'var(--primary-button-text-color)' }}
              label={t('home.allUpcomingClosing')}
            />
          </Link>
        )}
        {tileBtn.PendingReview && (
          <Link to="/pending-review">
            <Button 
              variant="tile"
              style={{ color: 'var(--primary-button-text-color)' }}
              label={t('home.pendingReview')}
            />
          </Link>
        )}
        {tileBtn.YTDFundedDeals && (
          <Link to="/ytd-funded-deals">
            <Button 
              variant="tile"
              style={{ color: 'var(--primary-button-text-color)' }}
              label={t('home.ytdFundedDeals')}
            />
          </Link>
        )}
        {tileBtn.SearchDeals && (
          <Link to="/search-deals">
            <Button 
              variant="tile"
              style={{ color: 'var(--primary-button-text-color)' }}
              label={t('home.searchDeals')}
            />
          </Link>
        )}
      </div>
    </section>
  );
}

export default Home;